import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {first, map, mergeMap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isZorgAtHomeApi(request.url)) {
      return this.getRequestWithToken(request)
        .pipe(mergeMap(requestWithToken => next.handle(requestWithToken)));
    } else {
      return next.handle(request);
    }
  }

  private isZorgAtHomeApi(url: string): boolean {
    return url.startsWith(environment.apiUrl);
  }

  private getRequestWithToken(request: HttpRequest<any>): Observable<HttpRequest<any>> {
    return this.authService.getToken$()
      .pipe(
        first(),
        map(token => request.clone({setHeaders: {Authorization: `Bearer ${token}`}}))
      );
  }
}
